module.exports = __webpack_public_path__ + "img/P22-zh.1a390ae8.png";